module.exports = __webpack_public_path__ + "static/pattern-6142e86dcc187cb66ce3fa8993dc9f2f.jpg";